import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import styles from "./TermsSection.module.scss";
import LogoHeader from "../../Home/HomePageImages/LogoHeader.png";
import Modal from "../../../components/Modal";

export const TermsSection = () => {
  const navigate = useNavigate();

  const [applicationIsOpen, setApplicationIsOpen] = useState<boolean>(false);
  return (
    <>
      <div className={styles.TermsSection}>
        <div className={styles.Info}>
          <Link to="/">
            <img src={LogoHeader} alt="Logo" className={styles.Logo} />
          </Link>
          <p>8 (989) 299-10-10</p>
        </div>

        <div className={styles.TermsSectionContent}>
          <h1>УСЛОВИЯ</h1>
          <div className={styles.TermsSectionContentText}>
            <div>
              <p>
                <b>
                  <span>Правила использования сервиса</span>
                </b>
              </p>

              <p>
                <b>
                  <span>Платформы РУМСЕЛЛЕР</span>
                </b>
              </p>

              <p>
                <b>
                  <span>Содержание:</span>
                </b>
              </p>

              <p>
                <span>
                  <a href="#terminology">
                    <span>1. Терминология</span>
                  </a>
                </span>
                <span>.</span>
              </p>

              <p>
                <span>
                  <a href="#provisions">
                    <span>2. Общие положения</span>
                  </a>
                </span>
                <span>.</span>
              </p>

              <p>
                <span>
                  <a href="#purpose">
                    <span>
                      3. Назначение платформы РС, общие условия регистрации,
                      оформления Заказа и документооборота на платформе РС.
                    </span>
                  </a>
                </span>
              </p>

              <p>
                <span>
                  <a href="#design">
                    <span>
                      4. Оформление Заказа. Заключение договоров через агентский
                      сервис платформы РС.
                    </span>
                  </a>
                </span>
              </p>

              <p>
                <span>
                  <a href="#payment">
                    5. Оплата Заказа и организации услуг по доставке Товаров.
                  </a>
                </span>
              </p>

              <p>
                <span>
                  <a href="#formation">
                    6. Формирование Отправления, его доставка и приемка.
                  </a>
                </span>
              </p>

              <p>
                <span>
                  <a href="#cancel">
                    <span>
                      7. Отмена заказа. Возврат и отказ Продавца от Товара
                    </span>
                  </a>
                </span>
                <span>.</span>
              </p>

              <p>
                <a href="#usage">
                  <span>
                    8. Использование сервиса платформы РС при совпадении
                    Поставщика и Продавца в одном лице.
                  </span>
                </a>
              </p>

              <p>
                <a href="#agency">
                  <span>
                    9. Агентское вознаграждение ООО «Румселлер». Взаиморасчеты
                    сторон. Оформление документов.
                  </span>
                </a>
              </p>

              <p>
                <span>
                  <a href="#informational">
                    <span>
                      10. Информационное сопровождение рассмотрения претензий
                      Продавцов.
                    </span>
                  </a>
                </span>
              </p>

              <p>
                <span>
                  <a href="#services">
                    <span>11. Услуги по организации доставки Товаров</span>
                  </a>
                </span>
                <span>.</span>
              </p>

              <p>
                <span>
                  <a href="#others">
                    <span>12. Прочие условия.</span>
                  </a>
                </span>
              </p>

              <p>
                <span>&nbsp;</span>
              </p>
              <div style={{ height: "100px" }} id="terminology"></div>
              <p>
                <b>
                  <span>1. Терминология</span>
                </b>
              </p>

              <p>
                <b>
                  <span>Платформа Румселлер (далее платформа РС) </span>
                </b>
                <span>- веб-сайт по адресу </span>
                <u>
                  <span>www</span>
                </u>
                <u>
                  <span>.</span>
                </u>
                <u>
                  <span>roomseller</span>
                </u>
                <u>
                  <span>.</span>
                </u>
                <u>
                  <span>ru</span>
                </u>
                <u>
                  <span> </span>
                </u>
                <span>
                  в информационно - телекоммуникационной сети Интернет
                </span>
                <span>
                  , прикладные программы (в том числе программы для мобильных
                  приложений), предоставляющие доступ к базе данных в пределах
                  конкретных потребностей для соответствующего взаимодействия
                  Поставщиков и Продавцов в целях последующей реализации товаров
                  с использованием дистанционного способа (дистанционной
                  торговли), т.е. через маркетплейсы.{" "}
                </span>
              </p>

              <p>
                <span>
                  База данных представляет собой информационно-справочную
                  систему со всеми приложениями, содержащую информацию
                  Поставщиков о товарах, предназначенную для Продавцов,
                  осуществляющих продажи этих товаров через маркетплейсы
                  Покупателям.
                </span>
              </p>

              <p>
                <b>
                  <span>Маркетплейс </span>
                </b>
                <span>- </span>
                <span>магазин дистанционной торговли в </span>
                <span>информационно - коммуникационной </span>
                <span>
                  сети Интернет, предоставляющий информацию о товарах или
                  услугах третьих лиц.
                </span>
              </p>

              <p>
                <b>
                  <span>Поставщик – </span>
                </b>
                <span>
                  коммерческая организация<b> </b>(юридическое лицо любой
                  организационно - правовой формы, зарегистрированное и
                  осуществляющее свою деятельность в соответствии с
                  законодательством РФ), и/или физическое лицо (гражданин
                  Российской Федерации или государства, входящего в Евразийский
                  экономический союз (ЕАЭС)), являющееся индивидуальным
                  предпринимателем или обладающее статусом самозанятого по
                  действующему законодательству РФ, которая (-ое):
                </span>
              </p>

              <p>
                <span>- является непосредственным производителем товаров;</span>
              </p>

              <p>
                <span>
                  - является Оптовым продавцом, предлагающим к реализации
                  значительные партии товара для их дальнейшей перепродажи
                  Продавцами;
                </span>
              </p>

              <p>
                <span>
                  - размещает достоверную и полную информацию о своих товарах на
                  платформе РС;
                </span>
              </p>

              <p>
                <span>
                  - поставляет товары по заказам, оформляемым Покупателями по
                  заказам Продавцов, сформированным на платформе РС,{" "}
                </span>
              </p>

              <p>
                <span>
                  заключившее договор оферты с ООО «Румселлер» и давшее
                  обязательство соблюдать настоящие Правила использования
                  сервиса платформы Румселлер, размещенные в информационно –
                  телекоммуникационной сети Интернет по адресу:
                </span>
                <span> </span>
                <span>:</span>
                <span> https://roomseller.ru/terms</span>
                <u>
                  <span>,</span>
                </u>
                <span>
                  путем их (договора и Правил) подписания квалифицированной
                  электронной подписью, соответствующей требованиям{" "}
                </span>
                <a>
                  <span>
                    Федерального закона от 06.04.2011 N 63-ФЗ «Об электронной
                    подписи».
                  </span>
                </a>
              </p>

              <p>
                <b>
                  <span>Продавец (розничный продавец) -</span>
                </b>
                <span>
                  {" "}
                  коммерческая организация (юридическое лицо любой
                  организационно-правовой формы,
                </span>
                <span>
                  {" "}
                  зарегистрированное и осуществляющее свою деятельность в
                  соответствии с законодательством РФ), а также{" "}
                </span>
                <span>
                  физическое лицо (гражданин Российской Федерации или
                  государства, входящего в Евразийский экономический союз
                  (ЕАЭС)), являющееся индивидуальным предпринимателем или
                  обладающее статусом самозанятого,{" "}
                </span>
                <span>
                  осуществляющие деятельность по продаже товаров Покупателям с
                  использованием дистанционного способа (дистанционной
                  торговли), т.е. через свои торговые площадки (магазины),
                  зарегистрированные и расположенные на маркетплейсах,
                  заключившая (-ее) договор оферты с ООО «Румселлер» и давшее
                  обязательство соблюдать настоящие Правила использования
                  сервиса платформы Румселлер, размещенные в информационно –
                  телекоммуникационной сети Интернет по адресу:
                </span>
                <a></a>
                <span> https://roomseller.ru/terms</span>
                <u>
                  <span>,</span>
                </u>
                <span>
                  {" "}
                  путем их (договора и Правил) подписания квалифицированной
                  электронной подписью, соответствующей требованиям
                </span>
                <span>
                  Федерального закона от 06.04.2011 N 63-ФЗ «Об электронной
                  подписи».
                </span>
              </p>

              <p>
                <span>
                  При совпадении Поставщика и Продавца в одном лице
                  использование сервиса платформы РС производится в порядке,
                  предусмотренном разделом 8 настоящих Правил.{" "}
                </span>
              </p>

              <p>
                <b>
                  <span>Договор с Поставщиком</span>
                </b>
                <span>
                  {" "}
                  – размещаемый на платформе РС единый для всех Поставщиков
                  договор на оказание услуг с использованием информационного
                  (агентского) сервиса платформы Румселлер, предоставляемых ООО
                  «Румселлер».
                </span>
              </p>

              <p>
                <b>
                  <span>Договор с Продавцом</span>
                </b>
                <span>
                  {" "}
                  – размещаемый на платформе РС единый для всех Продавцов
                  договор на оказание услуг с использованием информационного
                  (агентского) сервиса платформы Румселлер, предоставляемых ООО
                  «Румселлер».{" "}
                </span>
              </p>

              <p>
                <b>
                  <span>Пользователь платформы РС</span>
                </b>
                <span>
                  {" "}
                  – Поставщик или Продавец, осуществляющие взаимодействие с
                  использованием информационного (агентского) сервиса платформы
                  РС.
                </span>
              </p>

              <p>
                <b>
                  <span>Покупатель (Конечный Потребитель)</span>
                </b>
                <span>
                  {" "}
                  - физическое лицо, приобретающее Товары у Продавца
                  дистанционным способом посредством оформления заказа Товаров в
                  магазине Продавца на любом из маркетплейсов, например, таких
                  как: Озон (
                </span>
                <span>Ozon</span>
                <span>), Вайлдберриз (</span>
                <span>W</span>
                <span>ildberries), ЯндексМаркет (</span>
                <span>Yandex</span>
                <span> </span>
                <span>Market</span>
                <span>) и др.</span>
              </p>

              <p>
                <b>
                  <span>Товары -</span>
                </b>
                <span>
                  {" "}
                  принадлежащие Поставщикам товары, предложения о продаже
                  которых они размещают на платформе РС, а также{" "}
                </span>
                <span>
                  товары, являющиеся предметом договора купли-продажи между
                  Продавцом и Покупателем с использованием агентских услуг
                  (агентирование) платформы РС путем оформления Покупателем
                  заказа по установленной форме, его оплаты в порядке,
                  предусмотренном настоящими Правилами, формирования Поставщиком
                  Отправления по оформленному и оплаченному заказу, последующей
                  приемки товаров Продавцом с подписанием накладных в
                  соответствии с настоящими Правилами.{" "}
                </span>
              </p>

              <p>
                <b>
                  <span>Пункты приема/выдачи заказов (Брендированные)</span>
                </b>
                <span>
                  {" "}
                  - стационарные места, брендированные информационными
                  материалами соответствующего маркетплейса, и осуществляющие
                  выдачу заказов Конечным Потребителям, указавшим адрес
                  соответствующего Пункта выдачи заказов в качестве места
                  доставки.
                </span>
              </p>

              <p>
                <b>
                  <span>Первичный заказ Покупателя –</span>
                </b>
                <span>
                  {" "}
                  заказ Покупателем конкретного Товара по его выбору на любом
                  маркетплейсе в соответствии с правилами этого маркетплейса.
                </span>
              </p>

              <p>
                <b>
                  <span>Заказ </span>
                </b>
                <span>
                  – агрегированный заказ от Продавца (-цов) Поставщику (-кам),
                  автоматически сформированный посредством использования
                  информационного (агентского) сервиса платформы РС на основе
                  группирования первичных заказов Покупателей, сделанных ими
                  через магазин(-ны) Продавца(-цов), расположенный (-ые) на том
                  или ином маркетплейсе, включая доставку заказа до пункта
                  приема/выдачи заказов конкретного маркетплейса, указанного
                  Поставщиком.
                </span>
              </p>

              <p>
                <b>
                  <span>Отправление </span>
                </b>
                <span>
                  - Товар или совокупность Товаров, надлежащим образом
                  сформированных и подготовленных Поставщиком на основании
                  заказа Продавца, для дальнейшей доставки Покупателю. Право
                  собственности на Товар или совокупность Товаров,
                  сформированный (-ных) в Отправление, переходит к Продавцу в
                  момент подписания им (Продавцом) накладных по форме ТОРГ - 12
                  в порядке, установленном настоящими Правилами и
                  соответствующим Договором.
                </span>
              </p>

              <p>
                <span>
                  Право собственности на Товар (-ы), содержащийся (-иеся) в
                  Отправлении, не переходит к ООО «Румселлер» ни в период
                  оформления заказа Покупателем, ни в период формирования
                  Отправления на основании заказа Продавца, ни в период доставки
                  Отправления, ни в любой другой период взаимодействия между
                  Поставщиком, платформой РС и Продавцом в отношении заказанного
                  Покупателем Товара (-ов), включая документационное оформление
                  и оплату.
                </span>
              </p>

              <p>
                <b>
                  <span>ООО «РУМСЕЛЛЕР»</span>
                </b>
                <span>
                  (Румселлер, РС) - юридическое лицо, созданное и осуществляющее
                  деятельность в соответствии с законодательством Российской
                  Федерации,{" "}
                </span>
                <span>
                  ОГРН 1232300070023, ИНН 2308294780, КПП 230801001, юридический
                  адрес:{" "}
                </span>
                <span>
                  350910, Краснодарский край, г.о. город Краснодар, г.
                  Краснодар, тер. Пашковский жилой массив, ул.им. Кирова, д.265,
                  кв.188.
                </span>
              </p>

              <p>
                <b>
                  <span>Личный кабинет</span>
                </b>
                <span>
                  {" "}
                  - программный интерфейс взаимодействия Продавца/Поставщика с
                  сервисом платформы РС, который содержит информацию о
                  Продавце/Поставщике, данные статистики и иную информацию в
                  отношении предоставляемых/получаемых услуг, а также
                  предоставляет возможность удаленного взаимодействия в рамках
                  конкретных заказов, доступный Продавцу/Поставщику после
                  авторизации с использованием своего логина и пароля на
                  платформе РС через прикладные программы (в том числе программы
                  для мобильных устройств) или API.
                </span>
              </p>

              <p>
                <b>
                  <span>Карточка товара</span>
                </b>
                <span>
                  {" "}
                  - совокупность сведений о предлагаемом к продаже на платформе
                  РС Товаре, содержащая, в числе прочего, Контент, а также иную
                  информацию о Товаре, его модификациях, характеристиках,
                  комплектации, доведение которой до сведения потребителей
                  является обязательным в силу действующего законодательства
                  Российской Федерации в сфере защиты прав потребителей.
                  Карточка товара является визуальным отображением товарного
                  предложения Поставщика. Товарное предложение, содержащееся в
                  Карточке товара в каждый конкретный момент времени,
                  определяется в соответствии с правилами, установленными
                  соответствующим маркетплейсом, на котором у конкретного
                  Продавца имеется личный кабинет. Обязательными атрибутами
                  Карточки Товара являются:
                </span>
              </p>

              <p>
                <span>
                  - код Товара, автоматически присваиваемые учетной системой
                  Поставщика при размещении Товара на платформе РС;
                </span>
              </p>

              <p>
                <span>
                  - артикул Товара, автоматически присваиваемый Товару
                  платформой РС;
                </span>
              </p>

              <p>
                <span>
                  - динамика изменения цены Товара с указанием даты и времени ее
                  последнего изменения.
                </span>
              </p>

              <p>
                <b>
                  <span>Склад</span>
                </b>
                <span> - отдельный раздел на платформе РФ (веб-сайт </span>
                <a>
                  <u>
                    <span>www</span>
                  </u>
                </a>
                <u>
                  <span>.</span>
                </u>
                <u>
                  <span>roomseller</span>
                </u>
                <u>
                  <span>.</span>
                </u>
                <u>
                  <span>ru</span>
                </u>
                <u>
                  <span>)</span>
                </u>
                <span>
                  ,{" "}
                  <a>
                    где хранится автоматически обновляемая в режиме реального
                    времени (24/7 каждые 2 мин.) база данных, формируемая на
                    основании информации, получаемой от Поставщиков, с учетом
                    сделанных и оплаченных (зарезервированных) Заказов. Каждый
                    Поставщик самостоятельно определяет периодичность обновления
                    информации о своих Товарах.
                  </a>
                </span>
              </p>

              <p>
                <b>
                  <span>Электронная подпись</span>
                </b>
                <span>
                  {" "}
                  - информация в электронной форме, которая присоединена к
                  другой информации в электронной форме (подписываемой
                  информации) или иным образом связана с такой информацией и
                  которая используется для определения лица, подписывающего
                  информацию.
                </span>
              </p>

              <p>
                <b>
                  <span>Участники электронного взаимодействия</span>
                </b>
                <span>
                  {" "}
                  - осуществляющие обмен информацией и документацией в
                  электронной форме Поставщики и Продавцы при использовании
                  информационного (агентского) сервиса платформы РС в целях
                  заключения договоров купли – продажи Товаров.
                </span>
              </p>

              <p>
                <b>
                  <span>Простая электронная подпись</span>
                </b>
                <span>
                  {" "}
                  - электронная подпись, которая посредством использования
                  кодов, паролей или иных средств подтверждает факт формирования
                  электронной подписи определенным лицом.
                </span>
                <span>
                  {" "}
                  Информация в электронной форме, подписанная простой
                  электронной подписью, признается электронным документом,
                  равнозначным документу на бумажном носителе, подписанному
                  собственноручной подписью, в соответствии с соглашением между
                  участниками электронного взаимодействия. Положения такого
                  соглашения содержатся в Договорах оферты с Поставщиком и
                  Продавцом, являющимся обязательными к подписанию
                  Пользователями. Иные документы, не указанные в договорах к
                  подписанию простой электронной подписью, должны быть подписаны
                  квалифицированной электронной подписью, соответствующей
                  требованиям{" "}
                </span>
                <span>
                  Федерального закона от 06.04.2011 N 63-ФЗ «Об электронной
                  подписи».
                </span>
              </p>

              <p>
                <span>
                  В настоящих Правилах (в том числе в приложениях к ним) могут
                  быть использованы термины, не определенные в настоящем
                  разделе. В этом случае толкование такого термина производится
                  в соответствии с текстом Правил (и приложений к ним). В случае
                  отсутствия однозначного толкования термина в тексте Правил
                  следует руководствоваться толкованием термина, определенным, в
                  первую очередь, законодательством РФ, во вторую очередь -
                  сложившимся (общеупотребительным) в деловом обороте и
                  информационно – телекоммуникационной сети Интернет.
                </span>
              </p>

              <p>
                <span>&nbsp;</span>
              </p>
              <div style={{ height: "100px" }} id="provisions"></div>
              <p>
                <b>
                  <span>2. Общие положения</span>
                </b>
              </p>

              <p>
                <span>
                  2.1. Используя информационный (агентский) сервис платформы РС,
                  Пользователь (Поставщик или Продавец) в безусловном и
                  бесспорном порядке соглашается с настоящими Правилами в полном
                  объеме и обязуется неукоснительно их соблюдать.
                </span>
              </p>

              <p>
                <span>
                  Платформа РС предоставляет Пользователю осуществляемую на
                  платной основе возможность предложения и/или поиска информации
                  о Товарах, ознакомления с товарными предложениями Поставщиков,
                  возможность получения (в т.ч. по результатам поиска)
                  релевантных интересам Продавцов и Покупателей товарных
                  предложений и информации, а также иные функциональные
                  возможности, явно доступные Пользователю в соответствии с
                  заключаемым между Пользователем и платформой РС договором -
                  офертой.
                </span>
              </p>

              <p>
                <span>
                  2.2. При использовании Пользователем платформы РС персональная
                  информация обрабатывается на условиях и для целей,
                  определённых в Политике конфиденциальности, размещенной в
                  информационно – телекоммуникационной сети Интернет по адресу:
                </span>
                <span> https://roomseller.ru/terms.</span>
              </p>

              <p>
                <span>
                  2.3. Пользователь соглашается с тем, что размещенные им на
                  платформе РС сообщения и материалы могут быть
                  использованы/переработаны платформой РС с помощью технологий
                  искусственного интеллекта. Переработанные сообщения и
                  материалы могут быть использованы на тех же условиях, что и
                  первоначальные сообщения, а также материалы Пользователя.
                </span>
              </p>

              <p>
                <span>
                  При наличии соответствующей технической возможности на
                  платформе РС Пользователю может предоставляться информация,
                  созданная или сформированная с использованием технологий
                  искусственного интеллекта. Указанная информация может
                  содержать в себе ошибки и неточности. Платформа РС не несет
                  ответственности за точность, релевантность и корректность
                  такой информации, а также не гарантирует бесперебойную работу
                  функциональности технологий искусственного интеллекта. По
                  умолчанию первоисточником предоставляемой на платформе РС
                  достоверной информации являются Пользователи
                  (Поставщик/Продавец). При наличии на платформе РС информации,
                  сгенерированной с помощью технологий искусственного
                  интеллекта, в обязательном порядке рядом с заголовком
                  проставляется соответствующая отметка «ИИ».
                </span>
              </p>

              <p>
                <span>
                  2.4. Если товарное предложение Поставщика на платформе РС
                  показано со скидкой, то размер такой скидки определяется
                  автоматически на основе предоставленной Поставщиком информации
                  о новой и старой цене путем вычитания новой цены из старой,
                  определения размера скидки в процентах от старой цены и
                  округления итогового значения скидки до целого числа по
                  общепринятым математическим правилам.
                </span>
              </p>

              <p>
                <span>
                  2.5. Пользуясь платформой РС, Пользователь в соответствии с ч.
                  1 ст. 18{" "}
                </span>
                <span>
                  Федерального закона от 13.03.2006 N 38-ФЗ «О рекламе»
                </span>
                <span>
                  {" "}
                  дает свое согласие на получение сообщений рекламного
                  характера. Пользователь вправе отказаться от получения
                  сообщений рекламного характера путем отключения
                  соответствующего функционала в настройках платформы РС своего
                  личного кабинета.
                </span>
              </p>

              <p>
                <span>
                  2.6. На платформе РС Пользователям доступна база данных,
                  которая представляет собой информационно-справочную систему,
                  содержащую достоверную и полную информацию о Товарах,
                  предназначенных для дальнейшей реализации их Покупателям,
                  пользующимся услугами дистанционной торговли через
                  маркетплейсы.
                </span>
              </p>

              <p>
                <span>
                  Информация о Товарах на платформе РС полностью основана на
                  данных, предоставленных Поставщиками, и регулярно (в режиме
                  24/7) обновляется в соответствии со предоставляемыми ими
                  сведениями. ООО «Румселлер» не несет ответственности за
                  несоответствие Товара, информация о котором указана в карточке
                  Товара, имеющемуся в наличии Товару, сформированному
                  Поставщиком в Отправление.
                </span>
              </p>

              <p>
                <span>
                  2.7. Платформа РС в любое время может изменять текст настоящих
                  Правил и документов, регулирующих использование платформы РС и
                  указанных в настоящих Правилах. Такие изменения вступают в
                  силу с момента публикации на официальном сайте платформы РС.
                  Актуальный (действующий на текущий момент) текст настоящих
                  Правил с указанием номера и даты редакции размещается по
                  адресу:
                </span>
                <span> https://roomseller.ru/terms.</span>
              </p>

              <p>
                <span>Пользователи платформы</span>
                <span> </span>
                <span>
                  РС обязаны подписать новую редакцию Правил и иных документов в
                  предусмотренном этим документами порядке.
                </span>
              </p>

              <p>
                <span>
                  Актуальной (обязательной к исполнению) Пользователями
                  платформы РС является более поздняя по дате размещения на
                  сайте редакция Правил.
                </span>
              </p>

              <p>
                <span>
                  2.8. Пользователям в целях неукоснительного соблюдения правил
                  использования простой электронной подписи, содержащихся в
                  Договорах, запрещено использовать на платформе РС более одного
                  аккаунта за исключением случаев, предусмотренных разделом 8
                  Правил. Платформа РС вправе заблокировать доступ Пользователя
                  к использованию сервиса платформы РС в случае выявления
                  использования любым Пользователем нескольких аккаунтов, не
                  подпадающих по действие раздела 8 Правил.{" "}
                </span>
              </p>

              <p>
                <span>
                  При этом ежемесячная абонентская плата за пользование
                  платформой РС (если Пользователь - Продавец) за текущий месяц
                  подлежит оплате в порядке, предусмотренном Договором с
                  Продавцом, и, в случае уже произведенной оплаты за текущий
                  месяц, возврату не подлежит.
                </span>
              </p>

              <p>
                <span>
                  Оплата вознаграждения ООО «Румселлер» пользователем-
                  Поставщиком производится в бесспорном и безусловном порядке,
                  предусмотренном Договором с Поставщиком и настоящими
                  Правилами.
                </span>
              </p>

              <p>
                <span>
                  2.9. Пользователь несет ответственность за сохранность и
                  конфиденциальность своих регистрационных данных (логин и
                  пароль). Все и любые действия, осуществленные на платформе РС
                  с использованием логина и пароля Пользователя, считаются
                  осуществленными Пользователем.
                </span>
              </p>
              <div style={{ height: "100px" }} id="purpose"></div>
              <p>
                <b>
                  <span>
                    3. Назначение платформы РС, общие условия регистрации,
                    оформления Заказа и документооборота на платформе РС.
                  </span>
                </b>
              </p>

              <p>
                <span>
                  3.1. Платформа РС является агрегатором и предназначена для
                  оптимизации взаимодействия Поставщиков и Продавцов с
                  использованием преимуществ дистанционной торговли, главным из
                  которых является практически неограниченное число
                  потенциальных покупателей - пользователей Интернета и т.п., в
                  целях существенного обоюдовыгодного увеличения объема продаж:
                </span>
              </p>

              <p>
                <span>
                  - Поставщиками - за счет расширения их доли присутствия на
                  маркетплейсах (помимо традиционных для них каналов сбыта
                  производимой продукции);{" "}
                </span>
              </p>

              <p>
                <span>
                  - Продавцами - за счет расширения и пополнения ассортимента
                  предлагаемых к реализации на маркетплейсах товаров, по ценам
                  Поставщиков, с возможностью получения полной и достоверной
                  информации обо всех товарах на одной площадке (платформе РС).
                </span>
              </p>

              <p>
                <span>
                  3.2. Регистрация на платформе РС осуществляется Пользователем
                  с обязательным заполнением всех полей, указанных в форме,
                  расположенной по адресу:{" "}
                </span>
                <span>
                  <a href="https://roomseller.ru/register">
                    <span>https</span>://<span>roomseller</span>.<span>ru</span>
                    /<span>register</span>
                  </a>
                </span>
                <u>
                  <span>. </span>
                </u>
                <span>
                  Пользователь обязан подписать форму квалифицированной
                  электронной подписью,{" "}
                </span>
                <span>соответствующей требованиям </span>
                <span>
                  Федерального закона от 06.04.2011 N 63-ФЗ «Об электронной
                  подписи».
                </span>
              </p>

              <p>
                <span>
                  3.3. Пользователь обязан указать достоверные данные о себе при
                  регистрации на платформе РС. Указание Пользователем
                  недостоверных, некорректных, несуществующих номера телефона,
                  юридического и фактического адреса, адреса электронной почты,
                  официального наименования (или ФИО) Пользователя, а также
                  любых других недостоверных сведений признается ООО «Румселлер»
                  недобросовестным поведением, влечет за собой отказ в
                  регистрации на платформе РС (предоставлении личного кабинета)
                  или расторжение во внесудебном порядке Договора - оферты,
                  заключенного с Пользователем.
                </span>
              </p>

              <p>
                <span>
                  3.4. Первичный заказ того или иного Товара (-ов) Покупатель
                  осуществляет самостоятельно через личный кабинет (магазин)
                  Продавца на том или ином маркетплейсе. Заказ автоматически
                  поступает в личный кабинет Поставщика на платформе РС с учетом
                  имеющейся на ней актуальной информации о товарах от
                  Поставщиков в соответствии с его кодом и артикулом Товара,
                  указанными в Карточке Товара.{" "}
                </span>
              </p>

              <p>
                <span>
                  Поступление заказа в личный кабинет Поставщика, с учетом
                  использования агентских услуг платформы РС и предварительной
                  оплаты заказа в соответствии с настоящими Правилами и
                  подписанным вместе с Правилами Договором (рамочным договором в
                  соответствии со ст.429.1 Гражданского кодекса РФ), является
                  заключением Продавцом договора купли-продажи соответствующих
                  товаров с конкретным Поставщиком. Отсутствие предварительной
                  оплаты является основанием для отказа Поставщика от
                  формирования Отправления по заказу Покупателя.
                </span>
              </p>

              <p>
                <span>
                  3.5. Осуществляя предварительную оплату услуг по организации
                  Поставщиком доставки соответствующего заказа до пункта
                  приема/выдачи заказов конкретного маркетплейса через
                  агентирование платформы РС по тарифам Поставщика в порядке,
                  предусмотренном настоящими Правилами и соответствующим
                  Договором, Продавец заключает договор по организации доставки
                  с конкретным Поставщиком.
                </span>
              </p>

              <p>
                <span>
                  3.6. В рамках заключенного на платформе РС договора
                  купли-продажи товаров и договора об оказании услуг по доставке
                  товара до пункта приема/выдачи заказов соответствующего
                  маркетплейса только Продавец вступает в договорные отношения с
                  Поставщиком, у которого приобретает Товары и заказывает услугу
                  по их доставке, хотя и с использованием агентских услуг ООО
                  «Румселлер».
                </span>
              </p>

              <p>
                <span>
                  Оформление Поставщиком накладных по форме ТОРГ-12 в адрес ООО
                  «Румселлер», последующее оформление ООО «Румселлер» накладных
                  от своего имени на имя Продавца на заказанный через личный
                  кабинет (магазин) Продавца Товар(-ы) и их доставку в порядке,
                  установленном настоящими Правилами и Договором - офертой, а
                  также соответствующая оплата заказа/доставки заказа при
                  участии агентского сервиса платформы РС производится
                  исключительно для учета объема агентских услуг, оказанных ООО
                  «Румселлер» Пользователям, во имя достижения целей создания и
                  функционирования платформы РС, указанных в п.3.1 настоящих
                  Правил. Указанные действия ООО «Румселлер» ни при каких
                  условиях не рассматриваются и не могут рассматриваться как
                  заключение договоров купли - продажи Товара(-ов) между
                  Поставщиком, ООО «Румселлер» и Продавцом.
                </span>
              </p>

              <p>
                <span>
                  3.7. При оформлении заказа очевидные ошибки, включая опечатки,
                  допущенные в описании Товара либо в описании услуги по
                  доставке, юридически обязывающими для сторон не являются.
                </span>
              </p>

              <p>
                <span>
                  Поступление заказа в личный кабинет Поставщика на платформе РС
                  и его оплата в порядке, установленном настоящими Правилами,
                  означает согласие Продавца со всеми существенными условиями
                  договора продажи Товара Поставщиком или оказания Поставщиком
                  услуг по организации доставки Товаров.
                </span>
              </p>

              <p>
                <span>
                  3.8. Существенные условия заключаемого Продавцом с Поставщиком
                  договора купли-продажи Товара (-ов) указываются в
                  опубликованной на платформе РС Карточке Товара (-ов) и
                  накладных по форме ТОРГ-12, последовательно оформляемых
                  Поставщиком и ООО «Румселлер».
                </span>
              </p>

              <p>
                <span>
                  3.9. Существенные условия заключаемого Продавцом с Поставщиком
                  договора на оказание услуг по организации доставки Товара
                  указываются в накладных по форме ТОРГ -12, последовательно
                  оформляемых Поставщиком и ООО «Румселлер», в настоящих
                  Правилах и в Договорах.
                </span>
              </p>

              <p>
                <span>
                  3.10. В рамках произведенного заказа платформа РС
                  предоставляет Поставщику и Продавцу агентские услуги по
                  полному информационному и документационному сопровождение
                  фактически заключенного ими между собой договора купли-продажи
                  Товаров, а также возможность оплаты заказа с помощью
                  агентского сервиса платформы РС. При этом взаимные права и
                  обязательства по оплате заказа и поставке заказанного товара
                  возникают непосредственно у Поставщика и Продавца, несмотря на
                  участие ООО  «Румселлер» в документообороте, связанном с
                  куплей-продажей Товаров, указанном в п.3.6 настоящих Правил.
                </span>
              </p>

              <p>
                <span>
                  3.11. Пользователь (Поставщик/Продавец) дает платформе РС
                  согласие на обработку персональной информации Пользователя,
                  как этот термин определен в Политике конфиденциальности{" "}
                  <a>(</a>
                </span>
                <span>
                  https://roomseller.ru/terms
                  <a href="https://yandex.ru/legal/confidential/index.html">
                    <span>
                      ), платформой РС для целей предоставления полного спектра
                      функциональных возможностей платформы РС, а также на
                      передачу платформой РС персональной информации
                      Пользователя партнёрам платформы РС, размещающим товарные
                      предложения на платформе РС, и их уполномоченным
                      представителям для дальнейшей обработки такой информации в
                      целях предоставления Пользователю функциональной
                      возможности платформы РС по поиску и ознакомлению с
                      товарными предложениями, направления таким партнёрам
                      запросов о приобретении соответствующих товаров.
                    </span>
                  </a>
                </span>
              </p>

              <p>
                <span>
                  Пользователь подтверждает свое согласие с тем, что
                  персональная информация, которую Пользователь предоставляет
                  платформе РС при использовании платформы РС, в том числе при
                  оформлении заказа, оплате Товаров при оформлении на платформе
                  заявления на возврат Товаров и денежных средств, уплаченных за
                  Товары, может быть передана платформой РС:
                </span>
              </p>

              <p>
                <span>
                  ·
                  <span>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  </span>
                </span>
                <span>
                  Поставщику, с которым Продавец посредством сервиса платформы
                  РС заключает договор купли-продажи Товаров и/или договор на
                  оказание услуг по организации доставки Товаров, для целей
                  исполнения Поставщиком указанных договоров с Продавцом;
                </span>
              </p>

              <p>
                <span>
                  ·
                  <span>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  </span>
                </span>
                <span>
                  кредитным организациям, участвующим в проведении операций,
                  совершаемых Продавцом с использованием платежных карт при
                  оплате Товаров на платформе РС, в целях подтверждения по
                  запросу кредитной организации факта осуществления таких
                  операций.
                </span>
              </p>

              <p>
                <span>
                  3.12. Пользователь настоящим уведомлен, понимает и соглашается
                  с тем, что при использовании платформы РС для целей
                  предоставления Пользователю всех имеющихся функциональных
                  возможностей платформе РС в автоматическом режиме передается
                  следующая обезличенная информация: тип операционной системы
                  устройства Пользователя, версия и идентификатор браузера,
                  статистика использования функций платформы РС, а также иная
                  техническая информация.
                </span>
              </p>

              <p>
                <span>
                  3.13. Пользователь соглашается с тем, что платформа РС вправе
                  хранить указанную выше персональную информацию Пользователя, в
                  течении срока использования Пользователем сервиса платформы РС
                  и не менее трех лет с даты последнего использования им сервиса
                  платформы РС.
                </span>
              </p>

              <p>
                <span>
                  3.14. Пользователь настоящим уведомлен, понимает и соглашается
                  с тем, что мобильное приложение «Платформа РС» может собирать
                  и передавать третьим лицам – партнерам платформы РС
                  обезличенные данные о точном местонахождении и параметрах
                  движения мобильного устройства, на котором установлено
                  мобильное приложение «Платформа РС», полученные от
                  GPS-модуля/устройства, или о приблизительном местонахождении
                  такого мобильного устройства, определённом по активной соте
                  оператора связи, sim-карта которого в данный момент
                  используется в таком мобильном устройстве, для персонализации
                  предоставляемых платформой РС функций, в том числе в части
                  получения Продавцом заказов в пунктах приема заказов, а также
                  для отображения в мобильном приложении платформы РС
                  персонализированных рекламных предложений.
                </span>
              </p>

              <p>
                <span>
                  3.15. Осуществляя/принимая к исполнению Заказ, Пользователь
                  подтверждает, что а)полностью ознакомился с положениями
                  настоящих Правил, б)полностью понимает настоящие Правила, а
                  также предмет и условия договора купли-продажи и доставки
                  Товаров (в случае оказания Поставщиком услуг по организации
                  доставки Товара) Поставщиком, в)полностью понимает значение и
                  последствия своих действий в отношении заключения и исполнения
                  заключенных с помощью сервиса платформы РС договоров.
                </span>
              </p>

              <p>
                <b>
                  <span>&nbsp;</span>
                </b>
              </p>
              <div style={{ height: "100px" }} id="design"></div>
              <p>
                <b>
                  <span>4. Оформление заказа. </span>
                </b>
              </p>

              <p>
                <b>
                  <span>Заключение договоров купли – продажи </span>
                </b>
              </p>

              <p>
                <b>
                  <span>через агентский сервис платформы РС.</span>
                </b>
              </p>

              <p>
                <span>
                  4.1. В рамках одного заказа Продавец также может заключать
                  договоры на организацию доставки с каждым Поставщиком, чьи
                  товары приобретает по договору купли-продажи.
                </span>
              </p>

              <p>
                <span>
                  4.2. Платформа РС предоставляет Продавцу возможность в рамках
                  одного заказа заключать фактические договоры купли – продажи
                  товаров, а также фактические договоры на организацию доставки
                  с несколькими Поставщиками одновременно (агрегированный
                  заказ).{" "}
                </span>
              </p>

              <p>
                <span>
                  4.3. Данные о заказанных Товарах автоматически отображаются на
                  платформе РС и группируются по личным кабинетам Продавцов и
                  соответствующим маркетплейсам. Платформа РС формирует один
                  общий заказ за операционный день с разбивкой по Продавцам и
                  Поставщикам от каждого маркетплейса.
                </span>
              </p>

              <p>
                <span>
                  4.4. Моментом окончания оформления заказа является поступление
                  заказа в личный кабинет Поставщика на платформе РС. Цена на
                  выбранный товар фиксируется на момент окончания оформления
                  заказа.
                </span>
              </p>

              <p>
                <span>
                  4.5. Первичный заказ,{" "}
                  <span>
                    оформленный Покупателем на маркетплейсе, а также его отмена
                    автоматически отображается в разделе «Заказы» в личном
                    кабинете Продавца на платформе РС.{" "}
                  </span>
                </span>
              </p>

              <p>
                <span>
                  Продавец вправе при формировании заказа требовать от
                  Поставщика всю необходимую информацию и документацию на
                  товары, указанные в заказе, в объеме, предусмотренном
                  действующим законодательством РФ.
                </span>
              </p>

              <p>
                <span>
                  4.6. Формирование заказов каждому Поставщику от разных
                  Продавцов производится с помощью агентского сервиса платформы
                  РС путем использования имеющегося в Карточке товара, артикула
                  Товара, а также номера заказа Покупателя, который
                  автоматически присваивается маркетплейсом заказу в момент
                  оформления его Покупателем.
                </span>
              </p>

              <p>
                <span>
                  Платформа РС каждому Поставщику автоматически собирает и
                  передает заказы всех Покупателей на имеющиеся у него и
                  указанные в его Карточках товары с разбивкой по маркетплейсам
                  и Продавцам.
                </span>
              </p>

              <p>
                <a>
                  <span>4.7. После оформления Покупателем</span>
                </a>
                <a>
                  <span>
                    первичного заказа в его личном кабинете на каком-либо
                    маркетплейсе{" "}
                  </span>
                </a>
                <span>
                  в личном кабинете Продавца на платформе РС в разделе
                  «Накладные» автоматически ежедневно формируется агрегированная
                  электронная накладная по форме ТОРГ-12 в 2-х экземплярах с
                  указанием:
                </span>
              </p>

              <p>
                <span>
                  - артикула, количества и стоимости заказанных Товаров по цене,
                  зафиксированной в Карточке товара в момент окончания
                  оформления конкретного заказа;
                </span>
              </p>

              <p>
                <span>
                  - стоимости услуг по формированию Отправления, упаковке и
                  доставке до указанного Поставщиком пункта выдачи или
                  сортировочного центра;
                </span>
              </p>

              <p>
                <span>
                  - в качестве поставщика - ООО «Румселлер», в качестве
                  грузополучателя и плательщика - Продавца, указанного в заказе;
                </span>
              </p>

              <p>
                <span>
                  - номера заказа, присваиваемого заказу платформой РС в
                  соответствии с п.4.6 настоящих Правил.{" "}
                </span>
              </p>

              <p>
                <span>
                  Одновременно с накладной формируется счет на оплату с
                  указанием в качестве плательщика Продавца.
                </span>
              </p>

              <p>
                <span>
                  Подписание ООО «Румселлер» накладных и счета по конкретному
                  заказу осуществляется автоматически с проставлением штампа
                  «подписано простой электронной подписью».<b> </b>Направление
                  ООО «Румселлер» накладных и счета от своего имени Продавцу
                  является исключительно способом оказания агентских услуг в
                  виде документационного сопровождения купли-продажи между
                  Поставщиком и Продавцом, исполнением обязательств ООО
                  «Румселлер» в рамках соответствующих договоров оферты с
                  Продавцом и Поставщиком и не накладывает на ООО «Румселлер»
                  обязательств по поставке Товара Продавцу.
                  <span> </span>
                </span>
              </p>

              <p>
                <span>
                  Нумерация накладных и счетов производится автоматически с
                  учетом нумерации, присваиваемой соответствующим накладным по
                  конкретному заказу (номеру заказа). Сформированные и
                  подписанные ООО «Румселлер» накладные и счета хранятся в
                  личном кабинете Продавца на платформе РС<b>.</b>
                </span>
              </p>

              <p>
                <span>
                  4.8. В личном кабинете Поставщика на платформе РС в разделе
                  «Накладные» автоматически ежедневно формируется агрегированная
                  электронная накладная по форме ТОРГ-12 в 2-х экземплярах с
                  указанием:
                </span>
              </p>

              <p>
                <span>
                  - всех заказов, полученных Поставщиком от всех Продавцов;
                </span>
              </p>

              <p>
                <span>
                  - артикула, количества и стоимости заказанных Товаров по цене,
                  отмеченной в Карточке товара Поставщика на платформе РС в
                  момент окончания  оформления заказа;
                </span>
              </p>

              <p>
                <span>- номеров заказов.</span>
              </p>

              <p>
                <span>
                  - стоимости услуг Поставщика по формированию Отправлений,
                  упаковке и доставке до указанного Поставщиком пункта выдачи
                  заказов;
                </span>
              </p>

              <p>
                <span>
                  - в качестве плательщика - ООО «Румселлер». <a></a>
                </span>
              </p>

              <p>
                <span>
                  Подписание Поставщиком накладных осуществляется автоматически
                  с проставлением штампа «подписано простой электронной
                  подписью».
                </span>
              </p>

              <p>
                <span>
                  Нумерация накладных производится автоматически. Сформированные
                  и подписанные Поставщиком накладные хранятся в разделе
                  «Накладные» личного кабинета Поставщика на платформе РС.
                </span>
              </p>

              <p>
                <span>
                  4.9. С учетом п.4.6 настоящих Правил заполненная и оформленная
                  ООО «Румселлер» накладная на заказ на имя конкретного Продавца
                  может не соответствовать накладной на этот же заказ,
                  оформленной конкретным Поставщиком на имя ООО «Румселлер»
                  <b>. </b>
                </span>
              </p>

              <p>
                <span>
                  4.10. Оформление на платформе РС заказов и услуг по его
                  доставке, при условии достаточности и своевременного
                  пополнения средств на их оплату на депозите Продавца на
                  платформе РС в порядке, предусмотренном п.5.1 настоящих
                  Правил, является фактическим заключением Продавцом
                  соответствующих договоров купли-продажи товаров и договоров на
                  оказание услуг по организации доставки заказанных товаров с
                  Поставщиками, которым принадлежат товары.
                </span>
              </p>

              <p>
                <span>
                  4.11. При наличии соответствующей технической возможности
                  платформа РС вправе предоставить Продавцу возможность
                  осуществления оплаты с помощью Системы быстрых платежей (СБП)
                  Банка России, для чего на выставленном Продавцу счете
                  проставляется{" "}
                </span>
                <span>QR</span>
                <span>-код.</span>
              </p>

              <p>
                <span>Использование Продавцом для оплаты СБП/</span>
                <span>QR</span>
                <span>
                  -кода означает автоматическое согласие Продавца на списание
                  платформой РС или ее партнерами соответствующей суммы оплаты
                  заказа со счета (депозита) Продавца.{" "}
                </span>
              </p>

              <p>
                <span>
                  4.12. Выполнение Продавцом действий, указанных в п.п. 5.1 –
                  5.2. настоящих Правил, означает полное и безоговорочное
                  согласие Продавца с условиями соответствующего Договора -
                  оферты на оказание услуг с использованием платформы РС,
                  размещенного в сети Интернет по адресу:
                </span>
                <span>
                  {" "}
                  <a href="https://roomseller.ru/terms">
                    https://roomseller.ru/terms
                  </a>
                </span>
                <span>
                  , а также с условиями фактически заключенных им с конкретным
                  Поставщиком договоров купли-продажи Товара (-ов) через
                  агентский сервис платформы РС.
                </span>
              </p>

              <p>
                <span>
                  4.13. В момент выполнения Продавцом действий, указанных в п.п.
                  5.1. – 5.2. настоящих Правил, возникают взаимные обязательства
                  Поставщика – владельца Товара (-ов) и Продавца (с учетом
                  оформления их правоотношений через агентирование платформы РС
                  -в рамках договора купли-продажи товара(-ов) и, в случае
                  заключения договора на оказание услуг по организации доставки
                  товара (-ов) Поставщиком, также этого договора).
                </span>
              </p>

              <p>
                <span>
                  4.14. Выполнение Продавцом действий, указанных в п.п. 5.1. –
                  5.2. настоящих Правил, также означает, что:
                </span>
              </p>

              <p>
                <span>
                  ·
                  <span>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  </span>
                </span>
                <span>
                  информация о товаре (-ах) и услугах доведена до сведения
                  Продавца в полном объеме;
                </span>
              </p>

              <p>
                <span>
                  ·
                  <span>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  </span>
                </span>
                <span>
                  до оформления заказа на товар(-ры), принадлежащий (-ие)
                  конкретному Поставщику, а также на услуги по организации
                  доставки товара(-ов) Продавец ознакомился со всей информацией
                  о товарах и услугах, обязательное доведение которой до
                  потребителя предусмотрено законодательством о защите прав
                  потребителей;
                </span>
              </p>

              <p>
                <span>
                  ·
                  <span>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  </span>
                </span>
                <span>
                  предоставленные Продавцом данные о себе в оформленном на
                  платформе РС заказе являются достоверными.
                </span>
              </p>
              <div style={{ height: "100px" }} id="payment"></div>
              <p>
                <b>
                  <span>
                    5. Оплата заказа и услуг по организации доставки товара.
                  </span>
                </b>
              </p>

              <p>
                <span>
                  5.1. Для гарантированной оплаты заказов Продавец
                  предварительно вносит на депозит платформы РС денежные
                  средства в размере суммарной выручки за предыдущий месяц по
                  всем маркетплейсам, а также примерной суммы услуг по его
                  доставке. Допускается внесение иной суммы по усмотрению
                  Продавца.
                </span>
              </p>

              <p>
                <span>
                  Внесенные средства, а также их остаток отражаются в личном
                  кабинете Продавца на платформе РС.
                </span>
              </p>

              <p>
                <span>
                  На средства Продавца, находящиеся на депозите платформы РС,
                  проценты, предусмотренные ст.ст.317.1, 395 ГК РФ, не
                  начисляются и не выплачиваются.{" "}
                </span>
              </p>

              <p>
                <span>
                  5.2. Списание денежных средств с депозита Продавца на
                  платформе РС на расчетный счет Поставщика производится ООО
                  «Румселлер» в размере суммы оформленных заказов и услуг по их
                  доставке, но не более остатка средств, имеющихся на депозите
                  Продавца на платформе РС, в день поступления оформленного
                  заказа от Покупателя или, в случае окончания операционного
                  банковского дня на момент оформления заказа Покупателем, на
                  следующий банковский день.
                </span>
              </p>

              <p>
                <span>
                  С момента надлежащей оплаты (произведенной своевременно и в
                  полном размере) Товар  находится в резерве у Поставщика в
                  течение 24-х часов, и в отношении данного Товара заказы не
                  принимаются. При этом в личном кабинете Поставщика на карточке
                  Товара автоматически платформой РС проставляется надпись
                  красным цветом «зарезервировано _шт.».{" "}
                </span>
              </p>

              <p>
                <span>
                  В том случае, если сумма текущего заказа превышает остаток
                  средств на депозите Продавца, очередной заказ исполнению не
                  подлежит. Сообщение об этом, а также о необходимости пополнить
                  депозит до недостающей суммы автоматически направляется в
                  личный кабинет Продавца с указанием номера заказа, даты и
                  времени его оформления и сообщением «Для оплаты заказа
                  недостаточно средств на счете». Продавец обязан пополнить
                  депозит в течение 3-х (трех) рабочих дней с момента получения
                  соответствующего сообщения или уменьшить (переоформить)
                  текущий заказ до размера остатка средств на депозите.
                </span>
              </p>

              <p>
                <span>
                  Неоплаченный заказ до пополнения депозита формируется с
                  помощью агентского сервиса платформы РС, но не отправляется
                  Поставщикам для исполнения.{" "}
                </span>
              </p>

              <p>
                <span>
                  Кроме этого, также автоматически формируются, но не
                  отправляются Поставщикам все следующие заказы, поступившие от
                  данного Продавца после первого заказа, неоплаченного с помощью
                  имеющихся на его депозите средств.
                </span>
              </p>

              <p>
                <span>
                  В личном кабинете Продавца на платформе РС сформированные, но
                  неоплаченные заказы для удобства восприятия выделяются красным
                  цветом.
                </span>
              </p>

              <p>
                <span>
                  После пополнения Продавцом депозита в необходимом размере
                  последовательно (по дате и времени поступления) исполняются
                  все оформленные заказы Продавца, совокупная стоимость которых
                  не превышает остаток средств на депозите.
                </span>
              </p>

              <p>
                <span>
                  В случае отказа в пополнении депозита и/или переоформления
                  текущего заказа по истечении указанного срока (не более 72-х
                  часов) неоплаченный заказ Продавца считается аннулированным и
                  не подлежащим исполнению, равно как и все последующие заказы
                  Продавца.{" "}
                </span>
              </p>

              <p>
                <span>
                  В случае, если в течение 90-та календарных дней Продавец не
                  оформил ни одного заказа (независимо от маркетплейса), остаток
                  средств на его депозите подлежит возврату на расчетный счет
                  Продавца. Специального заявления на возврат средств не
                  требуется.
                </span>
              </p>

              <p>
                <span>
                  5.3. Днем внесения Продавцом средств на его депозит на
                  платформе РС считается день поступления денежных средств на
                  расчетный счет ООО «Румселлер».
                </span>
              </p>

              <p>
                <span>
                  5.4. Цена, по которой Поставщик реализует соответствующий
                  товар, указана в Карточке Товара, размещаемой на платформе РС,
                  и в момент поступления заказа в личный кабинет Поставщика на
                  платформе РС фиксируется в порядке, предусмотренном п.4.4
                  настоящих Правил.
                </span>
              </p>

              <p>
                <span>5.5. </span>
                <a>
                  <span>
                    В случаях, предусмотренных действующим законодательством,
                    при расчетах за заказ и услуги по организации доставки в
                    сети «Интернет» посредством электронных средств платежа – с
                    помощью QR-кода, через СБП или с использованием банковских
                    карт, - кассовый чек автоматически направляется на адрес
                    электронной почты, указанный Продавцом при оформлении
                    заказа.
                  </span>
                </a>
              </p>

              <p>
                <span>
                  5.6. Оплата товаров, вошедших в заказ, и услуг по организации
                  доставки товара (-ов), осуществляется ООО «Румселлер» на счет
                  Поставщика в порядке, установленном п.8.7 настоящих Правил.
                </span>
              </p>
              <div style={{ height: "100px" }} id="formation"></div>
              <p>
                <b>
                  <span>
                    6. Формирование Отправления, его доставка и приемка.
                  </span>
                </b>
              </p>

              <p>
                <span>
                  6.1. Формирование Отправления в соответствии с заказом
                  производится Поставщиком исходя из той цены на товар (-ы),
                  которая была указана в личном кабинете Поставщика на платформе
                  РС на момент оформления заказа Продавцом. Увеличение цены на
                  товар (-ры) после поступления Заказа от Продавца при
                  формировании Отправления не допускается. Продавец вправе
                  требовать от Поставщика формирования Отправления по той цене,
                  которая была указана на платформе РС в момент оплаты им заказа
                  в соответствии с п.п.4.4, 5.4 Правил.{" "}
                </span>
              </p>

              <p>
                <span>
                  6.2. Формирование Отправления производится Поставщиком в
                  точном соответствии (по ассортименту, артикулам и количеству)
                  с заказом, направленным в раздел «Заказы» на платформе РС.
                </span>
              </p>

              <p>
                <span>
                  6.3. Формирование Отправления осуществляется Поставщиком с
                  использованием видеосъемки, позволяющей детально зафиксировать
                  процесс сборки, упаковки Отправления и его идентификацию.
                </span>
              </p>

              <p>
                <span>
                  Поставщик обязан предоставлять видеозапись по письменному
                  запросу Продавца в течение всего ее срока хранения, т.е. 60-ти
                  (шестидесяти) календарных дней с даты формирования
                  Отправления.
                </span>
              </p>

              <p>
                <span>
                  Отсутствие видеозаписи является основанием для возложения на
                  Поставщика бесспорной имущественной ответственности за любые
                  убытки, причиненные Продавцу в связи с нарушением целостности
                  упаковки, а также несоответствия сформированного Отправления
                  надлежаще оформленному заказу по количеству и ассортименту
                  Товаров, включая убытки, заявленные Продавцу Конечными
                  потребителями.
                </span>
              </p>

              <p>
                <span>
                  6.4. Доставка Товаров осуществляется Поставщиком в пункт
                  приема/выдачи заказов соответствующего маркетплейса, указанный
                  им в личном кабинете на платформе РС.
                </span>
              </p>

              <p>
                <span>
                  6.5. Текущая информация о процессе доставки Товаров в
                  согласованный с Продавцом пункт приема/выдачи заказов
                  отображается в разделе «Заказы» путем отображения статуса
                  заказа в следующей последовательности формулировок: «резерв» -
                  «собран»-«доставляется»-«доставлен» - «получен», возможны
                  статусы «отменен», «спорный», «потерян».
                </span>
              </p>

              <p>
                <span>
                  Отображение статуса «доставлен» в разделе «Заказы» на
                  платформе РС является подтверждением надлежащего исполнения
                  обязательств Поставщика по поставке товаров и организации
                  услуг по их доставке.
                </span>
              </p>

              <p>
                <span>
                  6.6. Продавец обязан подписать электронные накладные ТОРГ -12
                  в качестве грузополучателя простой электронной подписью не
                  позднее 12-ти часов с момента появления  статуса Заказа
                  «доставлен» в разделе «Заказы» на платформе РС.
                </span>
              </p>

              <p>
                <span>
                  Право собственности на товар (-ы), сформированный (-ые) в
                  Отправление, переходит от Поставщика к Продавцу в момент
                  подписания Продавцом электронных накладных, полученных им от
                  ООО «Румселлер». До указанного момента право собственности на
                  товар (-ы) сохраняется у Поставщика.
                </span>
              </p>

              <p>
                <span>
                  6.7. Все взаимоотношения, связанные с куплей-продажей товара
                  (-ов) на платформе РС, возникают непосредственно между
                  Поставщиком и Продавцом. ООО «Румселлер» не является
                  Поставщиком/Продавцом товара (-ов), а также лицом,
                  уполномоченным Поставщиком на принятие и удовлетворение
                  требований Покупателей, адресованных Продавцу (-ам) в
                  отношении товара (-ов) ненадлежащего качества.
                </span>
              </p>

              <p>
                <i>
                  <span>&nbsp;</span>
                </i>
              </p>
              <div style={{ height: "100px" }} id="cancel"></div>
              <p>
                <b>
                  <span>
                    7. Отмена заказа. Возврат и отказ Продавца от товара.
                  </span>
                </b>
              </p>

              <p>
                <span>
                  7.1. <u>Отмена заказа Поставщиком</u>
                </span>
              </p>

              <p>
                <span>
                  Поставщик вправе отменить заказ в следующих случаях:
                </span>
              </p>

              <p>
                <span>
                  ·
                  <span>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  </span>
                </span>
                <span>
                  если Продавец не оплатил заказ в течение 24-х часов после
                  резервирования;
                </span>
              </p>

              <p>
                <span>
                  ·
                  <span>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  </span>
                </span>
                <span>
                  в иных случаях, когда Поставщик не может исполнить заказ
                  вследствие наступления условий непреодолимой силы (форс
                  мажор);
                </span>
              </p>

              <p>
                <span>
                  ·
                  <span>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  </span>
                </span>
                <span>
                   в случаях, предусмотренных действующим законодательством;
                </span>
              </p>

              <p>
                <u>
                  <span>7.2. Отмена заказа Продавцом</span>
                </u>
              </p>

              <p>
                <span>7.2.1. Е</span>
                <span>
                  сли Отправление с Товарами еще не передано Поставщиком в
                  доставку, Продавец может отменить заказ в своем личном
                  кабинете на маркетплейсе, при этом статус заказа на платформе
                  РС автоматически поменяется на «отменен».
                </span>
              </p>

              <p>
                <span>
                  7.2.2. Возврат оплаты за отмененный заказ осуществляется
                  Поставщиком в полном объеме полученной им суммы в безналичном
                  порядке на расчетный счет ООО «Румселлер» в срок не позднее
                  3-х рабочих дней с даты изменения статуса заказа на платформе
                  РС.
                </span>
              </p>

              <p>
                <span>
                  7.2.3. ООО «Румселлер» производит возврат денежных средств
                  Продавцу за отмененный заказ в безналичном порядке на его
                  депозит не позднее 1-го рабочего дня с даты получения возврата
                  оплаты от Поставщика.{" "}
                </span>
              </p>

              <p>
                <u>
                  <span>7.3. Возврат товара Продавцом.</span>
                </u>
              </p>

              <p>
                <span>
                  7.3.1. Возврат товара Поставщику осуществляется Продавцом
                  после обязательного согласования им возврата с маркетплейсом в
                  соответствии с порядком, предусмотренном правилами
                  маркетплейса. Без согласования с маркетплейсом товар возврату
                  Поставщику не подлежит, что не порождает встречной обязанности
                  Поставщика по возврату полученных им денежных средств за товар
                  Продавцу.
                </span>
              </p>

              <p>
                <span>
                  7.3.2. Согласование Продавцом возврата товара с маркетплейсом
                  не имеет обязательной силы для Поставщика, который принимает
                  решение о приеме или об отказе в приеме возвращенного ему
                  Продавцом товара в соответствии с настоящими Правилами и
                  действующим законодательством.
                </span>
              </p>

              <p>
                <span>
                  7.3.3. Возврат Продавцом товара надлежащего качества может
                  быть осуществлен в соответствии с правилами соответствующего
                  маркетплейса.
                </span>
              </p>

              <p>
                <span>
                  7.3.4. Возврат товара надлежащего качества возможен только в
                  случае, если:
                </span>
              </p>

              <p>
                <span>
                  а) сохранен товарный вид и потребительские свойства товара
                  (-ов), в том числе при отсутствии повреждения/вскрытия
                  заводской упаковки товара (-ов);
                </span>
              </p>

              <p>
                <span>
                  б) товар оказался бракованным, что подтверждено экспертным
                  заключением;
                </span>
              </p>

              <p>
                <span>
                  в) по вине Поставщика был отправлен товар, не указанный в
                  оформленном заказе;
                </span>
              </p>

              <p>
                <span>
                  7.3.5. Возврат технически сложного товара бытового назначения
                  надлежащего качества возможен в случае, если сохранены его
                  потребительские свойства и товарный вид, в том числе при
                  отсутствии повреждения/вскрытия заводской упаковки товара.
                </span>
              </p>

              <p>
                <span>
                  7.3.6. Товар не принимается Поставщиком к возврату, если:
                </span>
              </p>

              <p>
                <span>
                  а) при нарушении целостности/повреждении упаковки товар
                  находится в рабочем и неповрежденном состоянии;
                </span>
              </p>

              <p>
                <span>
                  б) возврат оформлен после окончания гарантийного срока,
                  указанного в карточке товара, исчисленного со дня, следующего
                  за днем получения товара (-ов) Продавцом;{" "}
                </span>
              </p>

              <p>
                <span>
                  в) повреждение товара произошло по вине соответствующего
                  маркетплейса;
                </span>
              </p>

              <p>
                <span>
                  г) осуществлен возврат товара, не указанного в оформленном
                  Продавцом первоначальном заказе.
                </span>
              </p>

              <p>
                <span>
                  7.3.7. Товары, не подлежащие возврату по основаниям,
                  предусмотренным п.7.3.6 настоящих Правил, могут быть
                  возвращены Продавцу или, по согласованию с ним, утилизированы.
                  В этом случае возврат и утилизация товаров осуществляется за
                  счет Продавца.{" "}
                </span>
              </p>

              <p>
                <span>
                  7.3.8. Возврат товара Продавцом осуществляется путем
                  оформления им заявки на возврат в личном кабинете Продавца на
                  платформе РС в разделе «Заказы».
                </span>
              </p>

              <p>
                <span>
                  Продавец формирует заявку на возврат с указанием артикулов,
                  количества товаров и причины их возврата по каждому
                  маркетплейсу и по пункту приема/выдачи заказов отдельно, при
                  этом, после формирования такой заявки, он должен указать в ней
                  штрих-код или QR-код, соответствующий текущей дате оформления.
                  Обновление штрих-кода или QR-кода, в случае если Поставщик по
                  каким-либо причинам не смог вовремя забрать товар со склада,
                  производится Продавцом ежедневно.
                </span>
              </p>

              <p>
                <span>
                  7.3.9. Возврат товара осуществляется через те же пункты
                  приема/выдачи, которые указал Поставщик.
                </span>
              </p>

              <p>
                <span>
                  7.3.10. Поставщик получает информацию о возврате проданного им
                  товара в своем личном кабинете на платформе РС автоматически,
                  после окончания оформления Продавцом заявки на возврат в
                  порядке, предусмотренном п.7.3.8 настоящих Правил.{" "}
                </span>
              </p>

              <p>
                <span>
                  7.3.11. Получив заявленный к возвращению товар (-ы) Поставщик,
                  после осмотра товара (-ов) и определения его (их) состояния
                  (товарного вида, имеющихся повреждений, работоспособности и
                  т.п.), принимает решение о приеме товара (-ов) к возврату и,
                  соответственно, о возврате Продавцу денежных средств за товар
                  (-ы), принятый (-е)к возврату, либо об отказе в приеме
                  возврата.
                </span>
              </p>

              <p>
                <span>
                  7.3.12. Решение Поставщика о приеме товара к возврату или об
                  отказе в приеме оформляется путем определения и подтверждения
                  Поставщиком статуса каждого товара, который заявлен к возврату
                  Продавцом: Поставщик в заявке на возврат товара (-ов),
                  поставленного (-ных) им Продавцу, оформленной им на платформе
                  РС, в отношении каждого товара, заявленного Продавцом на
                  возврат, с помощью соответствующих клавиш выбирает один из
                  следующих вариантов решения:
                </span>
              </p>

              <p>
                <span>
                  а) «Принять», что означает согласие Поставщика на возврат ему
                  товара и возврата оплаты за товар Продавцу в соответствии с
                  настоящими Правилами;
                </span>
              </p>

              <p>
                <span>
                  б) «Отказать», что означает несогласие Поставщика на возврат
                  ему товара и возврата оплаты за него Продавцу в соответствии с
                  настоящими Правилами», при этом Поставщик обязан указать
                  причину отказа в приеме возврата и приложить фотографии
                  товара, определенно и однозначно подтверждающие причины
                  отказа;
                </span>
              </p>

              <p>
                <span>
                  в) «Не поступил», что означает фактическое отсутствие товара в
                  полученном Поставщиком возврате, несмотря на указание на
                  возврат этого товара в заявке, оформленной Продавцом.{" "}
                </span>
              </p>

              <p>
                <span>
                  7.3.13. После определения Поставщиком статуса каждого из
                  товаров, заявленных на возврат, он подтверждает свое решение в
                  отношении всей заявки Продавца на возврат нажатием клавиши
                  «Подтвердить», при этом в личном кабинете Продавца и
                  Поставщика автоматически формируются накладные по форме
                  ТОРГ-12 на возврат товаров, в отношении которых Поставщиком
                  принято решением о приеме возврата, с указанием:
                </span>
              </p>

              <p>
                <span>
                  а) - артикула, количества и стоимости возвращаемых товаров по
                  цене Поставщика, отмеченной в Карточке товара на
                  соответствующем маркетплейсе на дату заказа товара Продавцом;
                </span>
              </p>

              <p>
                <span>
                  - в качестве грузополучателя - ООО «Румселлер», в качестве
                  отправителя - Продавца, оформившего соответствующий возврат;{" "}
                </span>
              </p>

              <p>
                <span>
                  б) - артикула, количества и стоимости возвращаемых товаров по
                  цене Поставщика, отмеченной Продавцом в Карточке товара на
                  платформе РС на дату заказа;
                </span>
              </p>

              <p>
                <span>
                  - в качестве грузополучателя - Поставщика, в качестве
                  отправителя – ООО «Румселлер».{" "}
                </span>
              </p>

              <p>
                <span>
                  Заполненная и оформленная ООО «Румселлер» накладная на возврат
                  товара полностью соответствует накладной на этот возврат,
                  оформленной Продавцом, за исключением информации об
                  отправителе и грузополучателе<b>. </b>
                </span>
              </p>

              <p>
                <span>
                  Одновременно с накладными формируются соответствующие счета на
                  сумму возврата  оплаты за принятый Поставщиком к возврату
                  товар.
                </span>
              </p>

              <p>
                <span>
                  Аналогичные накладные и счета на возврат товара формируются
                  между ООО «Румселлер» и Продавцом, где в качестве
                  грузополучателя указывается ООО «Румселлер», а в качестве
                  грузоотправителя – Продавец.
                </span>
              </p>

              <p>
                <span>
                  7.3.14. Сформированные на возврат товара накладные
                  подписываются сторонами простой электронной подписью, хранятся
                  на платформе РС, в личных кабинетах Поставщика и Продавца и,
                  после их подписания Продавцом, ООО «Румселлер» и Поставщиком,
                  являются основанием для учета суммы возврата во взаиморасчетах
                  между Продавцом, ООО «Румселлер» и Поставщиком в соответствии
                  с разделом 9<b> </b>настоящих Правил.
                </span>
              </p>

              <p>
                <span>&nbsp;</span>
              </p>
              <div style={{ height: "100px" }} id="usage"></div>
              <p>
                <b>
                  <span>
                    8. Использование сервиса платформы РС при совпадении
                    Поставщика и Продавца в одном лице.
                  </span>
                </b>
              </p>

              <p>
                <span>(раздел в настоящее время находится в разработке)</span>
              </p>
              <div style={{ height: "100px" }} id="agency"></div>
              <p>
                <b>
                  <span>
                    9. Агентское вознаграждение ООО «Румселлер». Взаиморасчеты
                    сторон. Оформление документов.
                  </span>
                </b>
              </p>

              <p>
                <span>
                  9.1. За использование сервиса платформы РС взимается агентское
                  вознаграждение, размер которого на текущий месяц
                  рассчитывается автоматически в процентах от оборота за
                  прошедший месяц и устанавливается одинаковым:
                </span>
              </p>

              <p>
                <span>- отдельно для всех Поставщиков;</span>
              </p>

              <p>
                <span>- отдельно для всех Продавцов.</span>
              </p>

              <p>
                <span>
                  9.2. Размер вознаграждения устанавливается соответствующим
                  Договором-офертой на оказание услуг с использованием платформы
                  РС, заключаемым ООО «Румселлер» с каждым Пользователем.
                  Договором - офертой может быть установлен льготный
                  (бесплатный) период при начале использования сервиса платформы
                  РС.{" "}
                </span>
              </p>

              <p>
                <span>
                  9.3. Расчет вознаграждения, взимаемого с Поставщика,
                  осуществляется исходя из его цен, указанных в Карточке товара.
                </span>
              </p>

              <p>
                <span>
                  Расчет вознаграждения, взимаемого с Продавца, осуществляется
                  исходя из цены реализации им товаров на соответствующем
                  маркетплейсе.{" "}
                </span>
              </p>

              <p>
                <span>
                  9.4. Подписание Пользователем (Поставщиком или Продавцом)
                  соответствующего Договора – оферты на оказание услуг с
                  использованием платформы РС в порядке, предусмотренном
                  настоящими Правилами и договором, означает его согласие на
                  оплату агентского вознаграждения в размере и порядке,
                  установленном настоящими Правилами и Договором – офертой. {" "}
                </span>
              </p>

              <p>
                <span>
                  9.5. Изменение размера вознаграждения производится ООО
                  «Румселлер» в одностороннем порядке, не требует согласия
                  Пользователей и вступает в силу на следующий день после
                  опубликования новой редакции Договора  - оферты на сайте
                  платформы РС в информационно – телекоммуникационной сети
                  «Интернет» по адресу:{" "}
                </span>
                <span> </span>
                <span>
                  <a href="http://www.roomseller.ru">
                    <span>www</span>.<span>roomseller</span>.<span>ru</span>
                  </a>
                </span>
                <u>
                  <span>. </span>
                </u>
                <span>
                  Об изменении размера вознаграждения направляется
                  автоматическое уведомление в личный кабинет Пользователя.{" "}
                </span>
              </p>

              <p>
                <span>9.6. Взаиморасчеты с Продавцом:</span>
              </p>

              <p>
                <span>
                  9.6.1. Ежемесячно 3-го числа месяца, следующего за отчетным,
                  для каждого Продавца в его личном кабинете на платформе РС
                  автоматически формируется Агентский отчет (далее – отчет) о
                  продажах товаров Продавца и о сумме начисленного агентского
                  вознаграждения, причитающего ООО «Румселлер» за истекший
                  месяц.
                </span>
              </p>

              <p>
                <span>
                  Отчет, в зависимости от технических возможностей платформы на
                  текущий момент, может формироваться в разрезе соответствующих
                  маркетплейсов и/или пунктов выдачи.
                </span>
              </p>

              <p>
                <span>
                  На основании Агентского отчета и одновременно с ним в личном
                  кабинете Продавца формируется Акт с отражением (за истекший
                  месяц):
                </span>
              </p>

              <p>
                <span>
                  - сумм, поступивших на депозит Продавца на платформе РС;
                </span>
              </p>

              <p>
                <span>
                  - сумм возмещения расходов ООО «Румселлер» на закупку товаров
                  для Продавца;
                </span>
              </p>

              <p>
                <span>
                  - сумм возвращенных им товаров и принятых к возврату
                  соответствующим Поставщиком;
                </span>
              </p>

              <p>
                <span>
                  - сумм начисленного агентского вознаграждения ООО «Румселлер»;
                </span>
              </p>

              <p>
                <span>
                  - остатка средств на депозите Продавца на 1-е число следующего
                  месяца.
                </span>
              </p>

              <p>
                <span>
                  Указанный акт является основанием для начисления ООО
                  «Румселлер» суммы агентского вознаграждения за истекший месяц.
                </span>
              </p>

              <p>
                <span>
                  9.6.2. Акт должен быть подписан Продавцом в 1-м экземпляре не
                  позднее 2-х рабочих дней с даты его получения. Подписание Акта
                  производится нажатием клавиши «Подписать». Подписанные акты
                  хранятся в разделе «Акты» личного кабинета Продавца на
                  платформе РС.
                </span>
              </p>

              <p>
                <span>
                  9.6.3. Оплата вознаграждения, причитающегося ООО «Румселлер»,
                  производится Продавцом на основании счета, выставляемого ему
                  ООО «Румселлер» в личный кабинет на платформе РС не позднее
                  3-х рабочих дней после подписания Продавцом Акта, указанного в
                  п. 9.6.1. настоящих Правил.
                </span>
              </p>

              <p>
                <span>
                  9.6.4. Ежемесячно не позднее 1-го числа следующего месяца
                  автоматически формируется и направляется в личный кабинет
                  Продавца Акт сверки взаиморасчетов с отражением сумм
                  зачисления денежных средств на депозит Продавца на платформе
                  РС и сумм начислений из Акта, составленного на основании
                  Агентского отчета, указанных в п. 9.6.1. настоящих Правил. Акт
                  сверки подписывается и хранится в порядке , указанном в пункте
                  9.6.2 настоящих Правил.
                </span>
              </p>

              <p>
                <span>9.7. Взаиморасчеты с Поставщиком:</span>
              </p>

              <p>
                <span>
                  9.7.1. ООО «Румселлер» на основании накладных и счетов,
                  полученных им от каждого Поставщика, самостоятельно
                  рассчитывает сумму причитающегося ООО «Румселлер» агентского
                  вознаграждения (платы за пользование платформой РС) за текущий
                  месяц в размере, предусмотренном Договором – офертой с
                  Поставщиком.
                </span>
              </p>

              <p>
                <span>
                  Перечисление Поставщикам средств за отправленные им Продавцам
                  товары производится ООО «Румселлер» 2 раза в месяц, не позднее
                  15-го числа и последнего дня текущего месяца, из средств,
                  хранящихся на депозитах соответствующих Продавцов, за вычетом
                  агентского вознаграждения ООО «Румселлер».
                </span>
              </p>

              <p>
                <span>
                  9.7.2. Ежемесячно 1-го числа месяца, следующего за отчетным,
                  для каждого Поставщика в его личном кабинете на платформе РС
                  автоматически формируется Агентский отчет (далее – отчет) о
                  продажах товаров Поставщика и о сумме начисленного
                  вознаграждения, причитающего ООО «Румселлер» за истекший
                  месяц.
                </span>
              </p>

              <p>
                <span>
                  9.7.3. На основании отчета и одновременно с ним в личном
                  кабинете Поставщика формируется Акт с отражением (за истекший
                  месяц):
                </span>
              </p>

              <p>
                <span>
                  - сумм и номеров накладных, оформленных Поставщиком на
                  отправленные им товары;
                </span>
              </p>

              <p>
                <span>
                  -сумм возвращенных ему товаров от Продавцов и принятых им к
                  возврату;
                </span>
              </p>

              <p>
                <span>
                  - сумм начисленного комиссионного вознаграждения,
                  причитающегося ООО «Румселлер».
                </span>
              </p>

              <p>
                <span>
                  9.7.4. Акт должен быть подписан Поставщиком в 1-экземпляре не
                  позднее 2-х рабочих дней с даты его получения. Подписание Акта
                  сверки производится нажатием клавиши «Подписать». Подписанные
                  акты хранятся в разделе «Акты» личного кабинета Поставщика на
                  платформе РС.
                </span>
              </p>

              <p>
                <span>
                  9.7.5. В том случае, если в результате сверки будет
                  установлено занижение суммы вознаграждения, причитающегося ООО
                  «Румселлер», разница подлежит учету при расчетах Поставщика и
                  ООО «Румселлер» в следующем месяце.
                </span>
              </p>

              <p>
                <span>
                  9.7.6. Ежемесячно не позднее 1-го числа следующего месяца
                  автоматически формируется и направляется в личный кабинет
                  Поставщика Акт сверки взаиморасчетов с отражением сумм
                  перечисления денежных средств Поставщику и сумм из Акта,
                  составленного на основании Агентского отчета, указанных в п.
                  9.7.2. настоящих Правил. Акт сверки подписывается и хранится в
                  порядке, установленном п.9.7.4 настоящих Правил.
                </span>
              </p>

              <p>
                <span>&nbsp;</span>
              </p>
              <div style={{ height: "100px" }} id="informational"></div>
              <p>
                <b>
                  <span>
                    10. Информационное сопровождение рассмотрения претензий
                    Продавцов
                  </span>
                </b>
              </p>

              <p>
                <span>
                  10.1. Платформой РС предоставляется информационное
                  сопровождение рассмотрения претензий Продавца к Поставщику,
                  поданной в течение 14 (четырнадцати) календарных дней с даты
                  получения Продавцом Товара (в том числе в рамках возврата
                  Пользователем Товаров в указанный срок в порядке,
                  предусмотренном п. 7.3 Правил).
                </span>
              </p>

              <p>
                <span>
                  10.2. Платформа РС предоставляет возможность Продавцу
                  урегулировать любую возникшую в рамках Заказа претензию к
                  Поставщику, поданную в течение указанного в п. 9.1 срока, с
                  использованием формы обратной связи на платформе РС в разделе
                  «Заказы». При этом Продавец выражает согласие с тем, что
                  содержание претензии и полученная в ходе рассмотрения
                  претензии информация может быть доступна платформе РС на
                  условиях Политики Конфиденциальности
                  <a>: </a>
                </span>
                <span>https://roomseller.ru/terms</span>
                <span>) </span>
                <span>
                  и передана Поставщику для разрешения возникшей претензии.
                </span>
              </p>

              <p>
                <span>
                  10.3. Поставщиком гарантируется возврат уплаченных за Товар
                  денежных средств, если предварительно оплаченный Продавцом
                  Товар не будет доставлен Покупателю по вине Поставщика. В
                  случае, если Заказ не был доставлен Покупателю по вине
                  Поставщика, Продавцу также гарантируется возврат денежных
                  средств, предварительно оплаченных за услуги по организации
                  доставки Товаров. Помимо этого, Поставщик  обязан уплатить
                  штраф, выставленный и уплаченный Продавцом соответствующим
                  маркетплейсом.
                </span>
              </p>

              <p>
                <span>
                  10.4. В случае если принятое Поставщиком по Заказу Товаров
                  решение не устроило Продавца, он имеет возможность привлечь
                  арбитра платформы РС к рассмотрению разногласий между
                  Продавцом и Поставщиком, решение которого по спору является
                  окончательным и не подлежит обжалованию.
                </span>
              </p>

              <p>
                <span>
                  При отказе от арбитра платформы РС действует порядок
                  разрешения споров, установленный действующим законодательством
                  РФ.{" "}
                </span>
              </p>

              <p>
                <span>
                  При этом юридически обязывающими стороны документами при
                  разрешении спора в соответствии с действующим
                  законодательством РФ являются:
                </span>
              </p>

              <p>
                <span>а) настоящие Правила;</span>
              </p>

              <p>
                <span>
                  б) Договор на оказание услуг с использованием платформы
                  Румселлер с поставщиком, размещенный в сети Интернет по
                  адресу:
                </span>
                <span> https://roomseller.ru/terms.</span>
                <span>)</span>
              </p>

              <p>
                <span>
                  в) Договор на оказание услуг с использованием платформы
                  Румселлер с продавцом, размещенный в сети Интернет по адресу:
                </span>
                <span> https://roomseller.ru/terms.)</span>
              </p>

              <p>
                <span>
                  10.5. Гарантии, указанные в п. 10.3 и п. 10.4. Правил,
                  предоставляются платформой РС Продавцу дополнительно к
                  обязательствам Поставщика, предусмотренным договором
                  купли-продажи с Поставщиком и действующим законодательством РФ
                  (в случае неисполнения Продавцом обязательства в соответствии
                  с решением арбитра).
                </span>
              </p>

              <p>
                <span>
                  10.6. Принятие на себя платформой РС указанных в п.п.9.3, 9.4
                  Правил гарантий не подразумевает наличие у платформы РС
                  полномочий на удовлетворение требований Продавцов, в том числе
                  связанных с ненадлежащим качеством Товара. Платформа РС не
                  является лицом, уполномоченным Поставщиком на принятие и
                  удовлетворение требований Продавцов в отношении Товара
                  ненадлежащего качества. Платформа РС не несет обязательств
                  перед Пользователями (Поставщиками или Продавцами) по
                  договорам купли-продажи Товаров.
                </span>
              </p>

              <p>
                <span>
                  10.7. Платформа РС ни при каких условиях не осуществляет
                  возмещение Продавцу убытков, связанных с продажей
                  некачественного Товара Поставщиком, а также выплату
                  Пользователю пеней за просрочку исполнения обязательств
                  Поставщиком. Соответствующие требования должны быть
                  предъявлены Продавцом непосредственно к Поставщику по
                  заключенному им с Продавцом договору купли-продажи Товара в
                  соответствии с действующим законодательством РФ.
                </span>
              </p>

              <p>
                <span>
                  10.8. Рассмотрение арбитром платформы РС разногласий между
                  Продавцом и Поставщиком не лишает стороны возможности
                  разрешения спора иными способами, предусмотренными
                  законодательством РФ.
                </span>
              </p>

              <p>
                <span>
                  10.9. В случае, когда арбитру платформы РС для принятия
                  решения по претензии требуются определенные сведения и/или
                  документы от Продавца, Продавец обязан незамедлительно
                  предоставить арбитру запрошенные им для целей принятия решения
                  по претензии сведения и документы (например, товарная
                  накладная, товарно-транспортная накладная, акт сдачи-приемки,
                  опись вложения, заключение экспертизы и т.п.) Непредоставление
                  Продавцом запрошенных документов арбитру может стать
                  основанием для вынесения арбитром решения по претензии в
                  пользу Поставщика.
                </span>
              </p>

              <p>
                <span>
                  10.10. Претензии Продавцов принимаются к рассмотрению при
                  условии, что они составлены в виде образа электронного
                  документа, подписаны усиленной квалифицированной электронной
                  подписью и направлены на электронный адрес{" "}
                </span>
                <span>info</span>
                <span>@</span>
                <span>roomseller</span>
                <span>.</span>
                <span>ru</span>
              </p>

              <p>
                <span>&nbsp;</span>
              </p>
              <div style={{ height: "100px" }} id="services"></div>
              <p>
                <b>
                  <span>11. Услуги по организации доставки Товаров</span>
                </b>
              </p>

              <p>
                <span>
                  11.1. Стоимость Услуг по организации доставки Товаров (далее –
                  Услуги) по каждому заказу определяется в соответствии с
                  ценами, указанными при оформлении заказа на платформе РС
                  каждым Поставщиком. Дата доставки указывается на платформе РС
                  при оформлении заказа. Поставщики не вправе изменять указанные
                  на данной странице цены в одностороннем порядке после
                   поступления заказа в личный кабинет Поставщика на платформе
                  РС.
                </span>
              </p>

              <p>
                <span>
                  11.2. Продавец обязан оплатить Услуги в предусмотренном
                  Правилами порядке (п.п. 5.1, 5.2 Правил).
                </span>
              </p>

              <p>
                <span>
                  11.3. В случае полной гибели/утраты доставляемого Продавцу
                  Товара в Отправлении Поставщик возмещает Продавцу сумму
                  внесенной Продавцу предварительной оплаты за Товар, а также
                  предварительно оплаченную за Услуги сумму (до подписания
                  Продавцом товарных накладных ТОРГ-12).
                </span>
              </p>

              <p>
                <span>
                  11.4. Поставщик не несет ответственности за невыполнение или
                  ненадлежащее выполнение обязательств в рамках оказания Услуг в
                  любом из перечисленных случаев:
                </span>
              </p>

              <p>
                <span>
                  если это явилось следствием несоблюдения Продавцом настоящих
                  Правил;
                </span>
              </p>

              <p>
                <span>
                  если это явилось следствием действий обстоятельств
                  непреодолимой силы: стихийные бедствия, приостановка действия
                  путей сообщения, снежные заносы и т.п;
                </span>
              </p>

              <p>
                <b>
                  <span>&nbsp;</span>
                </b>
              </p>
              <div style={{ height: "100px" }} id="others"></div>
              <p>
                <b>
                  <span>12. Прочие условия</span>
                </b>
              </p>

              <p>
                <span>
                  12.1. Пользователь, в случае, если он является физическим
                  лицом, действующим в качестве{" "}
                </span>
                <span>
                  индивидуального предпринимателя или обладающее статусом
                  самозанятого, осуществляющим коммерческую деятельность в
                  рамках, указанных в преамбуле настоящих Правил,{" "}
                </span>
                <span>
                  регистрацией на платформе РС и подписанием соответствующего
                  Договора подтверждает, что он является дееспособным и достиг
                  возраста, необходимого в соответствии с законодательством
                  Российской Федерации для совершения сделок, предусмотренных
                  настоящими Правилами.
                </span>
              </p>

              <p>
                <span>
                  12.2. В случае нарушения настоящих Правил платформа РС вправе
                  заблокировать Продавцу возможность осуществления заказов, а
                  Поставщику – возможность размещения информации об ассортименте
                  и номенклатуре своих товаров.
                </span>
              </p>

              <p>
                <span>
                  12.3. Некоторый функционал платформы РС может отличаться или
                  быть недоступен для Пользователя (Поставщик или Продавца) на
                  страницах сервиса, оптимизированных для мобильных устройств,
                  или в мобильном приложении «Платформа РС».
                </span>
              </p>

              <p>
                <span>
                  12.4. Платформа РС не несет ответственности за временные сбои
                  и перерывы в работе сервиса, и вызванные ими потери
                  информации, а также сохранность информации, правильность и
                  своевременность ее передачи и доставки.
                </span>
              </p>

              <p>
                <span>
                  12.5. Платформа РС в любое время без согласия Пользователя
                  может изменять текст настоящих Правил, такие изменения
                  вступают в силу с момента публикации. Актуальный (действующий
                  на текущий момент) текст настоящих Правил размещается по
                  адресу:
                  <u>
                    <span> </span>
                  </u>
                  :
                </span>
                <span> https://roomseller.ru/terms</span>
                <span>
                  .). Уведомление об изменении Правил автоматически формируются
                  и направляются в личные кабинеты Пользователей, которые
                  обязаны подписать их в порядке, установленном  настоящими
                  Правилами.
                </span>
              </p>

              <p>
                <span>&nbsp;</span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
